import * as React from "react";
import Questionnaire from "benchmarking-domain/questionnaire";
import {useCallback, useState} from "react";
import {JsonEditor} from "components/core/json-editor";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import Divider from "@mui/material/Divider";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Button from "@mui/material/Button";
import * as QuestionnaireSchema from "benchmarking-domain/schemas/questionnaire.schema.json";

interface QuestionnaireFormProps {
  questionnaire?: Questionnaire;
  onSubmit: (data: Questionnaire) => Promise<void>;
}

export function QuestionnaireForm({questionnaire, onSubmit}: QuestionnaireFormProps): React.JSX.Element {
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [jsonObject, setJsonObject] = useState<{}>({...questionnaire});

  const jsonChangeHandler = useCallback((data: any) => {
    setJsonObject(data);
  }, []);

  const submitChanges = useCallback(async () => {
    setIsSaving(true);
    try {
      await onSubmit(jsonObject as Questionnaire);
    } finally {
      setIsSaving(false);
    }
  }, [onSubmit, jsonObject])

  return (
    <Card sx={{overflow: "visible"}}>
      <CardHeader title="Questionnaire"/>
      <Divider/>
      <CardContent>
        <JsonEditor json={questionnaire} schema={QuestionnaireSchema} onChangeJson={jsonChangeHandler} />
      </CardContent>
      <Divider/>
      <CardActions sx={{justifyContent: 'flex-end'}}>
        <Button onClick={submitChanges} variant="contained" disabled={isSaving}>Save details</Button>
      </CardActions>
    </Card>

  );
}
